import * as React from 'react';
import { Accordion } from 'damco-components';
import PropertyDisplay from 'components/cost-revenue/PropertyDisplay';
import Table from 'components/data-table/Table';
import { IPaternList, IPattern } from 'views/job-costing/utils/models';
import { formatData, sortElementByKey } from 'utilities/util';
import { CUSTOMER_BILLING_ROUTES } from 'constants/routes';

export interface IProps {
    link: (url: string) => void;
    organisation: IPaternList[],
    locations: IPaternList[],
    jobIdDetails: IPaternList[],
    serviceType: IPaternList[],
    bookings: IPattern,
    cbl: IPattern,
    fcr: IPattern,
    clr: IPattern,
    equipmentTransportShipments: IPattern,
    voyages: IPattern,
    customerInvoice: IPattern,
    isExtraDocumentFeatureEnabled: boolean
}
class EqDetails extends React.Component<IProps> {
    public createLink = (data: any) => {
        this.props.link(String(`/job-costing/booking/${data!.id}`))
    }
    public render() {
        const newCBL: any = { ...this.props.cbl }
        if (newCBL.data && newCBL.data.length) {
            newCBL.data = newCBL.data.map((data: any) => {
                data.opsStatus = data.status
                return data
            })
        }
        const newEqTrans = { ...this.props.equipmentTransportShipments }
        if (newEqTrans && newEqTrans.data) {
            newEqTrans.data = newEqTrans.data.map((data: any) => {
                data.anyIssoSent = data.anyIssoSent.toString()
                return data
            })
        }
        const extraDocsETS = JSON.parse(JSON.stringify(newEqTrans));
        if (extraDocsETS.data && extraDocsETS.data.length) {
            extraDocsETS.data = extraDocsETS.data.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && (val.equipmentTransportShipmentDocumentNumber.startsWith('IED')));
        }
        const exceptExtraDocsETS = JSON.parse(JSON.stringify(newEqTrans));
        if (exceptExtraDocsETS.data && exceptExtraDocsETS.data.length) {
            exceptExtraDocsETS.data = exceptExtraDocsETS.data.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && !val.equipmentTransportShipmentDocumentNumber.startsWith('IED'));
        }
        const newCLR = { ...this.props.clr };
        if (newCLR && newCLR.data) {
            newCLR.data = newCLR.data.map((data: any) => {
                const newData = formatData([data])
                return newData[0]
            })
        }
        const customerData = this.props.customerInvoice;
        customerData.data = sortElementByKey(customerData.data, 'createdDate', true, 'date');
        const extraDocs = JSON.parse(JSON.stringify(this.props.fcr));
        if (extraDocs.data && extraDocs.data.length) {
            extraDocs.data = extraDocs.data.filter((val: any) => val.originalDocumentNumber && val.originalDocumentNumber.startsWith('EED'));
        }
        const exceptExtraDocs = JSON.parse(JSON.stringify(this.props.fcr));
        if (exceptExtraDocs.data && exceptExtraDocs.data.length) {
            exceptExtraDocs.data = exceptExtraDocs.data.filter((val: any) => val.originalDocumentNumber && !val.originalDocumentNumber.startsWith('EED'));
        }

        return (
            <div className="padding-top-large padding-bottom-large">
                <Accordion title={'Service type & substitution'}>
                    <PropertyDisplay data={[...this.props.serviceType]} id="serviceType" />
                </Accordion>
                <Accordion title={'Organisation'}>
                    <PropertyDisplay data={[...this.props.organisation]} id="organisation" />
                </Accordion>
                <Accordion title={'Locations'}>
                    <PropertyDisplay data={[...this.props.locations]} id="locations" />
                </Accordion>
                <Accordion title={'Job ID Details'}>
                    <PropertyDisplay data={[...this.props.jobIdDetails]} id="jobIdDetails" />
                </Accordion>
                <Accordion title={'cbl'}>
                    <Table {...newCBL}
                        id="equipments-details-cbl"
                        hasTotal={true}
                        linkAction={(row: any) => this.props.link(String(`/job-costing/cbls/${row!.id}`))} />
                </Accordion>
                <Accordion title={'clr'}>
                    <Table {...newCLR}
                        id="equipments-details-clr"
                        hasTotal={true}
                    />
                </Accordion>
                <Accordion title={'Booking'}>
                    <Table
                        {...this.props.bookings}
                        id="equipments-details-bookings"
                        hasTotal={true}
                        linkAction={(row: any) => { this.createLink(row) }} />
                </Accordion>
                {!this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'fcr'}>
                        <Table {...this.props.fcr} id="equipments-details-documents"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/documents/${row!.id}`))} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'Document'} id="fcr">
                        <Table {...exceptExtraDocs}
                            id="equipments-details-documents"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/documents/${row!.id}`))} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    extraDocs.data &&
                    extraDocs.data.length > 0 &&
                    <Accordion title={'Export Extra Document'} id="extra-document">
                        <Table {...extraDocs}
                            id="equipments-details-extra-document"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/documents/${row!.id}`))} />
                    </Accordion>
                }
                {!this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'EQUIPMENT TRANSPORT SHIPMENTS'}>
                        <Table {...newEqTrans} hasTotal={true}
                            id="equipments-details-equipmentTransportShipments"
                            linkAction={(row: any) => this.props.link(String(`/job-costing/ets/${row!.id}`))}
                        />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'EQUIPMENT TRANSPORT SHIPMENTS'}>
                        <Table {...exceptExtraDocsETS} id="equipments-details-equipmentTransportShipments"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/ets/${row!.id}`))} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    extraDocsETS.data &&
                    extraDocsETS.data.length > 0 &&
                    <Accordion title={'Import Extra Document'}>
                        <Table {...extraDocsETS} id="equipments-details-extraEquipmentTransportShipments"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/ets/${row!.id}`))} />
                    </Accordion>
                }
                <Accordion title={'VESSEL/VOYAGE'}>
                    <Table {...this.props.voyages} id="equipments-details-voyages" />
                </Accordion>
                <Accordion title={'Customer invoice'}>
                    <Table {...this.props.customerInvoice} id="equipments-details-customerInvoice"
                        linkAction={(row: any) => this.props.link(String(`${CUSTOMER_BILLING_ROUTES.CREDIT_NOTE}/origin/${row!.internalBillingNo}`))} />
                </Accordion>
            </div>
        );
    }
}

export default EqDetails;